// extracted by mini-css-extract-plugin
module.exports = {"main":"cda_a","el":"cda_b","l1":"cda_c","l2":"cda_d","r1":"cda_e"};